
import { useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { IoIosSave } from "react-icons/io";
import 'react-toastify/dist/ReactToastify.css';

import { toast } from 'react-toastify';


const DivGeral = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  padding: 25px;
  box-shadow: 0px 0px 2px #ccc;
`;


const Label = styled.label`
  color: #4f4f4f;
  font-weight: bold;
  font-size: 17px;  
  display: flex;
  flex-direction: column;

  select {
      &.erro {
      border: 2px solid red;
      
    }
  }
`;






const Div = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;

  select {
    width: 100px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 5px;
    height: 37px;
  }

`;


const Input1 = styled.input`

  width: 200px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
    &.erro {
      border: 2px solid red;
      
    }
`;


const Input2 = styled.input`
  width: auto;
  min-width: 500px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
`;
const Input3 = styled.input`
  width: 100px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
`;

const Input4 = styled.input`
  width: auto;
  min-width: 500px;
  height: 200px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
`;
const H2 = styled.h2`
  color: #575757;
`;

const Button = styled.button`
  padding: 10px 30px;
  background-color: transparent;
  color: #575757;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 22px;
  font-weight: bold;
  @media (max-width: 768px) {
    padding: 5px;
    font-size: 14px;
  }
  
`;


const Form = ({ urlApi, setAtualizaMateriais }) => {
  //========================================================TOKEN
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');

  //========================================================ENVIA O CODIGO/RECEBE A DESCRICAO

  const [codigoMaterial, setCodigoMaterial] = useState('');
  const [descricaoMaterial, setDescricaoMaterial] = useState('');



  const getMaterial = async (codigo) => {
    try {
      const response = await axios.get(`${urlApi}controle-reagentes/lancamento-material`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { codigoMaterial: codigo }
      });

      if (response.data.length > 0) {
        setDescricaoMaterial(response.data[0]);
      } else {
        toast.warn('Material não encontrado');
        setDescricaoMaterial({});
      }

    } catch (err) {
      console.log("Conexão falhou", err);
      toast.error('Erro ao buscar material');
      setDescricaoMaterial({});
    }
  };

  // Chama ao mudar o input e pressionar Enter ou sair do campo (onBlur)
  const handleBuscarMaterial = () => {
    if (codigoMaterial) {
      getMaterial(codigoMaterial);
    }
  };



  //========================================================ADICIONAR O MATERIAL NO LB_MATERIAL
  const [observacao, setObservacao] = useState('');
  const [quantidade, setQuantidade] = useState('');
  const [tipoSelecionado, setTipoSelecionado] = useState(null);
  const [situacaoSelecionado, setSituacaoSelecionado] = useState(null);
  const getDataHoje = () => {
    const hoje = new Date();
    const ano = hoje.getFullYear();
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    const dia = String(hoje.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  const [dataHora, setDataHora] = useState(getDataHoje());


  const [erros, setErros] = useState({});
  // Tratar o formato da quantidade
  const [quantidadeFormatada, setQuantidadeFormatada] = useState(''); // exibição
  const handleQuantidadeChange = (e) => {
    const valor = e.target.value;

    // Atualiza visualmente o que o usuário digitou
    setQuantidadeFormatada(valor);

    // Remove os pontos de milhar e troca vírgula por ponto
    const valorNormalizado = valor.replace(/\./g, '').replace(',', '.');

    // Converte para número e salva (se válido)
    const numero = parseFloat(valorNormalizado);

    if (!isNaN(numero)) {
      setQuantidade(numero);
    } else {
      setQuantidade(0); // ou null, dependendo da lógica
    }
  };


  const handleSalvarLancamento = async () => {


    if (observacao && observacao.length > 250) {
      toast.warn('A observação não pode ter mais de 250 caracteres.');
      return;
    }
    const novosErros = {};
    if (!codigoMaterial) novosErros.codigoMaterial = true;

    if (!quantidade || Number(quantidade) <= 0) {
      novosErros.quantidade = 'A quantidade deve ser maior que zero.';
    }



    if (!tipoSelecionado) novosErros.tipoSelecionado = true;

    setErros(novosErros);

    // Se houver erros, mostra toast opcionalmente e retorna
    if (Object.keys(novosErros).length > 0) {
      if (novosErros.quantidade) {
        toast.warn(novosErros.quantidade); // mostra toast específico
      } else {
        toast.warn('Preencha todos os campos obrigatórios.');
      }
      return;
    }

    setErros({});

    const precoUnitario = parseFloat(descricaoMaterial.ULTIMO_PRECO) || 0;
    const total = precoUnitario * qtd;


    try {
      const payload = {
        cod_material: codigoMaterial.trim(),
        quantidade: Number(quantidade.toFixed(2)),
        tipo: tipoSelecionado,
        observacao: observacao?.trim() || null,
        situacao: situacaoSelecionado,
        valor_unitario: precoUnitario,
        valor_total: total,
        saldo_cs: descricaoMaterial.QUANTIDADE_ESTOQUE,
        cod_funcionario_lancou: id,
        data: dataHora,

      };

      const res = await axios.post(
        `${urlApi}controle-reagentes/adicionar-lancamento`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success(res.data.message || 'Material salvo com sucesso!');
      setAtualizaMateriais(true);
    } catch (err) {
      console.error('Erro ao salvar material:', err);
      toast.error(err.response?.data?.error || 'Erro ao salvar material.');
    }

    setCodigoMaterial('');
    setDescricaoMaterial('');
    setObservacao('');
    setQuantidade('');
    setQuantidadeFormatada('');
    setTipoSelecionado('');
    setSituacaoSelecionado('');
  };



  //-------------------------------------VALOR TOTAL--------------------------------------------//
  const precoUnitario = Number(descricaoMaterial.ULTIMO_PRECO) || 0;
  const qtd = parseFloat(quantidade) || 0;
  const total = precoUnitario * qtd;

  const totalFormatado = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(total);




  return (
    <DivGeral>
      <H2>Lançamento de Materiais</H2>


      <Div>
        <Label>
          Data:
          <Input1
            type="date"
            value={dataHora}
            onChange={(e) => setDataHora(e.target.value)}
            required
          />
        </Label>


        <Label>
          Código do Material:
          <Input1
            type="text"
            value={codigoMaterial}
            className={erros.codigoMaterial ? 'erro' : ''}
            onChange={(e) => setCodigoMaterial(e.target.value)}
            onBlur={handleBuscarMaterial}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleBuscarMaterial();
            }}
            placeholder="Digite o código"
          />
        </Label>

        {/* Exibe a descrição do material */}
        <Label>
          Descrição:
          <Input2
            type="text"
            value={`${descricaoMaterial.DESC_MATERIAL || ''} `}
            disabled={(!codigoMaterial)}
            readOnly
          />

        </Label>
        <Label>
          Uni:
          <Input3
            type="text"
            value={` ${descricaoMaterial.UNIDADE_MEDIDA || ''}`}
            disabled={(!codigoMaterial)}
            readOnly

          />

        </Label>
      </Div>

      <Div>
        <Label>
          Quantidade:
          <Input1
            type="text"
            value={quantidadeFormatada}
            onChange={handleQuantidadeChange}
            placeholder="Digite a quantidade"
            disabled={!codigoMaterial}
          />
        </Label>


        {/*<Label>
          Tipo:
          <select
            value={tipoSelecionado || ''}
            className={erros.tipoSelecionado ? 'erro' : ''}
            disabled={!codigoMaterial}
            onChange={(e) => setTipoSelecionado(e.target.value)}
          >
            <option value="" disabled>Selecione o tipo</option>
            <option value="E">Entrada</option>
            <option value="S">Saída</option>
            <option value="A">Ajuste de Estoque</option>
            <option value="P">Perda / Quebra</option>
            <option value="D">Devolução</option>
          </select>
        </Label>*/}
        <Label>
          Tipo:
          <select
            value={tipoSelecionado || ''}
            className={erros.tipoSelecionado ? 'erro' : ''}
            disabled={!codigoMaterial}
            onChange={(e) => setTipoSelecionado(e.target.value)}
          >
            <option value="" disabled>Selecione o tipo</option>
            <option value="E">Entrada</option>
            <option value="S">Saída</option>
          </select>
        </Label>



        <Label>
          Situação:
          <select
            value={situacaoSelecionado || ''}
            disabled={!codigoMaterial}
            onChange={(e) => setSituacaoSelecionado(e.target.value)}
          >
            <option value="" disabled>Selecione a situação</option>
            <option value="AB">Aguardando baixa</option>
            <option value="BA">Baixado</option>
          </select>
        </Label>
        <Label>
          Valor unitário:
          <Input1
            type="text"
            value={
              codigoMaterial && descricaoMaterial.ULTIMO_PRECO
                ? new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(descricaoMaterial.ULTIMO_PRECO)
                : ''
            }
            disabled
            readOnly
          />
        </Label>

        <Label>
          Valor total:
          <Input1
            type="text"
            value={codigoMaterial ? totalFormatado : ''}
            disabled
            readOnly
          />
        </Label>


      </Div>
      <Div>
        <Label>
          Saldo no Sistema Secundário:
          <Input1
            type="text"
            value={descricaoMaterial.SALDO_ATUAL_LANCADO != null ? descricaoMaterial.SALDO_ATUAL_LANCADO : '0'}
            disabled
            readOnly
          />

        </Label>
        <Label>
          Saldo na CS:
          <Input1
            type="text"
            value={descricaoMaterial.QUANTIDADE_ESTOQUE != null ? descricaoMaterial.QUANTIDADE_ESTOQUE : '0'}
            disabled
            readOnly
          />

        </Label>
        <Label>
          Observação:
          <Input4
            type="text"
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
            disabled={!codigoMaterial}
            placeholder="Digite uma observação"
          />


        </Label>
      </Div>
      <Div>
        <Button
          disabled={!codigoMaterial}
          onClick={handleSalvarLancamento}
        >
          <IoIosSave color={"green"} />Salvar Lançamento
        </Button>
      </Div>

      <style jsx global>{`
        .swal2-container.custom-swal-container {
          z-index: 9999;
        }
      `}</style>
    </DivGeral>
  );
};

export default Form;




